import React from 'react';
import { modules } from '../data/content';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR } from '../data/constants';
export function Modules() {
  return <section className="bg-cream px-4 py-9 sm:px-6 sm:py-12" data-id="element-134" data-mp="1vx2awcxf9qs5">
      <div className="mx-auto max-w-6xl" data-id="element-135" data-mp="1vxlsfsj5ud5n">
        <p className="font-display text-[11px] font-bold uppercase tracking-[0.18em] text-sage-dark sm:text-xs" data-id="element-136" data-mp="20w5dlqpxjkwy">
          La collection professionnelle complète
        </p>
        <h2 className="mt-1.5 max-w-3xl text-xl font-extrabold leading-tight sm:text-3xl" data-id="element-137" data-mp="147z7ezdd0kgk">
          À l’intérieur du système — six modules professionnels complets
        </h2>

        <ul className="mt-5 grid gap-3 lg:grid-cols-2" data-id="element-138" data-mp="1d4zqqrlknsd5">
          {modules.map(module => <li key={module.num} data-id="element-139" data-mp="1i6gsepbvrius">
              <a href={OFFER_ANCHOR} className="flex h-full flex-col rounded-xl border border-sage/40 bg-white p-4 transition-colors duration-150 ease-out hover:border-gold sm:p-5" data-id="element-140" data-mp="1i3b0z3fs44vw">
                <div className="flex items-center gap-2.5" data-id="element-141" data-mp="1vl0l12oval4">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-petrol font-display text-sm font-extrabold text-gold" data-id="element-142" data-mp="1syt11fssv2w">
                    {module.num}
                  </span>
                  <span className="font-display text-[10px] font-bold uppercase tracking-[0.16em] text-sage-dark" data-id="element-143" data-mp="3k0obj2fc6gtg">
                    Module {module.num}
                  </span>
                </div>
                <h3 className="mt-2.5 text-[15px] font-extrabold leading-tight sm:text-lg" data-id="element-144" data-mp="3aawdfy8135k8">
                  {module.title}
                </h3>
                {module.paragraphs.map(text => <p key={text} className="mt-1.5 text-[13px] leading-snug text-graphite/80 sm:text-sm" data-id="element-145" data-mp="31a6lj5lw1zbs">
                    {text}
                  </p>)}
                <ul className="mt-auto flex flex-wrap gap-1.5 pt-3" data-id="element-146" data-mp="2wabu90y7b7q7">
                  {module.tags.map(tag => <li key={tag} className="rounded-full bg-cream-dark px-2 py-0.5 text-[10px] font-semibold text-petrol sm:text-[11px]" data-id="element-147" data-mp="2red00wq6yvhv">
                      {tag}
                    </li>)}
                </ul>
              </a>
            </li>)}
        </ul>

        <div className="mt-6 flex flex-col items-center gap-2" data-id="element-148" data-mp="2cqcyazi57imh">
          <CTAButton className="max-w-md" data-id="element-149" data-mp="30f5zpbhjaioh">Accédez à Orthophonie Pro™ maintenant</CTAButton>
          <p className="text-[11px] font-semibold text-graphite/70 sm:text-xs" data-id="element-150" data-mp="35dzcf1ozy5nl">
            Paiement Sécurisé · Accès Immédiat · Garantie 7 Jours
          </p>
        </div>
      </div>
    </section>;
}